import { Card, CardHeader, Grid2, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import { setCurrentPage, setRowsPerPage, setSelectedCategory, setTotalPages } from "./store/insurerKeyValueStore.js";
import MaterialSelect from "../../../components/MasterSelect/index.js"
import { deleteData, fetchData } from "../../../services/index.js"
import Table from "../../../components/Table/index.js"
import InsurerKVStoreFilterDialog from './components/InsurerKVStoreFilterDialog.js';

const InsurerKeyValueList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector(
        (state) => state?.insurerKeyValueStore?.currentPage
    );
    const rowsPerPage = useSelector(
        (state) => state?.insurerKeyValueStore?.rowsPerPage
    );
    const totalPages = useSelector(
        (state) => state?.insurerKeyValueStore?.totalPages
    );
    const selectedCategory = useSelector((state) => state?.insurerKeyValueStore?.selectedCategory) || null;
    
    const [isRefresh, setIsRefresh] = useState(false);
    const [keyValueData, setKeyValueData] = useState([]);
    const [insurerCategoryOptions, setInsurerCategoryOptions] = useState([]);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        gInsurerId: "",
        parentKeyId: "",
    });
    
    useEffect(() => {
        fetchInsurerKVStoreData(selectedCategory?.value)
    },[isRefresh, currentPage, rowsPerPage, search]);

    useEffect(() => {
        fetchInsurerCategoryData();
    },[]);

    //fetch category dropdown
    const fetchInsurerCategoryData = async () => {
        try {
            const response = await fetchData(`/reference/insurer/key-value-category?dropdown=true`);

            if (response?.success) {
                setInsurerCategoryOptions(
                    response?.data?.items.map((item) => ({
                    value: item.id,
                    label: item.categoryName,
                    }))
                );
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            showSnackbar("Error Fetching Dropdown Data", "warning");
        }
    };

    const fetchInsurerKVStoreData = async (id) => {
        try {

            let url = `/reference/insurer/key_value_store?categoryId=${id || ""}&searchTerm=${search}`;
            
            //for active and inactive status
            if(filterData.isActive !== "") {
                url += `&isActive=${filterData.isActive}`;
            }
            if(filterData.gInsurerId !== ""){
                url += `&gInsurerId=${filterData.gInsurerId}`;
            }
            if(filterData?.parentKeyId !== ""){
                url += `&parentKeyId=${filterData.parentKeyId}`;
            }
            const response = await fetchData(url);
            setKeyValueData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));
        } catch (error) {
            console.error("Error in fetching Key value Store");
        } finally {
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/insurer/key_value_store/-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error Deleting Data", "error");
        }
    };
    //on selecting category api function for key value list
    const handleCategoryChange = async (event) => {
        setCircleLoading(true);
        fetchInsurerKVStoreData(event?.value);
        dispatch(setSelectedCategory(event));
    };

    //table mapping
    const insurerKeyValueTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "keyName",
            label: "Key Name",
            renderCell: (row) => row.keyName,
            },
            {
            key: "gInsurerName",
            label: "Insurer Name",
            renderCell: (row) => row.gInsurerName,
            },
            {
            key: "category",
            label: "Category",
            renderCell: (row) => row.category,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row.createdAt,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],
        rows: keyValueData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            keyName: item?.keyName || "",
            category: item?.category?.categoryName || "",
            createdAt: new Date(item.createdAt).toLocaleDateString("en-GB"),
            gInsurerName: item?.gInsurerName,
            isActive: item?.isActive,
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/insurer-master/insurer-key-value/key-value-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/insurer-master/insurer-key-value/key-value-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handleAddNewKeyValue = () => {
        navigate("/insurer-master/insurer-key-value/key-value-details", {
        state: { categoryId: selectedCategory?.value, categoryName: selectedCategory?.label },
        });
    };
    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Insurer Key Value List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                Select a Category from the dropdown to get the Key Value Stores
                of that particular category based on Insurers.
              </MaterialTypography>
            </Stack>
            {selectedCategory?.value && (
            <Stack direction="row" spacing={1}>
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt/>}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                Filter
                </MaterialButton>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<Add />}
                  onClick={() => handleAddNewKeyValue()}
                >
                  Add {selectedCategory?.label}
                </MaterialButton>
            </Stack>
            )}
          </Stack>
        }
      />

    <Grid2 container spacing={2} alignItems="center" sx={{ mx: 2 }}>
        <Grid2 size={{ xs: 12, sm: 3 }}>
            <MaterialSelect
            name="categoryName"
            value={selectedCategory}
            customStyles={{ optionPadding: 20 }}
            onChange={handleCategoryChange} //selectedValue, event
            options={insurerCategoryOptions?.map((value) => {
                return {
                value: value.value,
                label: value.label,
                };
            })}
            />
        </Grid2>
    </Grid2>
    <Card sx={{ mx: 1, mt: 2 }}>
            <Table
            columns={insurerKeyValueTable?.columns}
            data={insurerKeyValueTable?.rows}
            actions={actions}
            pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) =>
                handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel={"No Key Value data found"}
            handleSearch={handleSearch}
          />
    </Card>
    <InsurerKVStoreFilterDialog
    anchorEl={anchorEl}
    open={open}
    onClose={() => setAnchorEl(null)}
    filterData={filterData}
    setFilterData={setFilterData}
    onApply={() => {
        setAnchorEl(null);   // close popup
        fetchInsurerKVStoreData(selectedCategory?.value);  // call API after filter applied
    }}
    categoryId={selectedCategory?.value}
    />
    </DashboardLayout>
  )
}

export default InsurerKeyValueList